import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from './../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import {ApiTextService} from '../../../apiServices/text/text.service';
import {SecurityService} from '../../../security.service';
import { PricingService } from '../../../pricing.service';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-internet-cyberlink',
  templateUrl: './internet-cyberlink.component.html',
  styleUrls: ['./internet-cyberlink.component.scss']
})
export class InternetCyberlinkComponent implements OnInit, OnDestroy {

  pricingListSoftphone = [];
  canHaveFreeSoftphone: boolean;
  promoSoftphone: boolean;

  constructor(public dataStorageService: DataStorageService,
              public securityService: SecurityService,
              private pricing: PricingService,
              private api: ApiService,
              private tApi: ApiTextService) {

                pricing.getPPHostedSoftphonePricelist().then(data => {
                  this.pricingListSoftphone = data;
                });
                
                
  }

  ngOnInit() {
    const element = document.getElementById('internetCyber');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['PeoplephoneInternetCyberlink'];
    this.api.getPPHosted(this.dataStorageService.currentState.offerID).then(() => {
      this.canHaveFreeSoftphone = this.dataStorageService.currentState.wishedSolution.PeoplephoneHosted 
                && ( this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetCyberlink 
                    || this.dataStorageService.currentState.wishedSolution.PeoplephoneInternetIPworldcom)
                this.promoSoftphone = this.canHaveFreeSoftphone 
                && this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost == 0
    })
  }

  setSofphonePrice(event) {
    let previousPrice = this.softphoneCost();
    this.promoSoftphone = event.target.checked
    let nextPrice = this.softphoneCost();

    if(this.promoSoftphone) {
      this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost = 0;
      this.dataStorageService.currentState.PPhosted.totalCost -= previousPrice;
    } else {
      this.dataStorageService.currentState.PPhosted.totalCost += nextPrice;
      this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost = nextPrice
    }
     
    this.api.putPPHosted(this.dataStorageService.currentState.offerID);
  }

  softphoneCost(): number {
    let cost = 0;
    if(this.promoSoftphone) return cost;

    this.pricingListSoftphone.forEach(elem => {
        cost = elem.costMonthly * this.dataStorageService.currentState.PPhosted.softphones;
    });

    return cost;
  }

  ngOnDestroy() {
    const element = document.getElementById('internetCyber');
    element.classList.remove('active');
  }

  updateText(event, key: string) {
    const value = event.target.value;
    this.tApi.putUIText(key, value);
    this.dataStorageService.setUIText(key, value);
  }

  getDesc() {
    return this.dataStorageService.filterUIText('offer.options.internet-cyberlink.desc');
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/internet-cyberlink/internet-cyberlink.component.ts